<div
  class="container-fluid m-0 p-5 block"
  [ngClass]="{ 'theme-darkk': themeService.flag }"
>
  <div class="text-center">
    <h2 class="font-pacifico">
      <span
        class="text-underline cursor-pointer"
        (click)="navigate('\projects')"
        >My Projects</span
      >.
    </h2>
  </div>
  <p class="tagline font-raleway">
    Here are some of the projects that I've done:
  </p>

  <div class="row justify-content-center">
    <div class="p-2 cards" *ngFor="let project of selected; let i = index">
      <div
        class="card my-card depth"
        [ngClass]="{ 'theme-light text-light border-light': themeService.flag }"
      >
        <div
          class="card-header justify-content-center d-flex"
          [ngClass]="{
            'theme-light text-light border-light': themeService.flag
          }"
        >
          <img
            [src]="project.logo"
            [alt]="project.title"
            class="card-img-top rounded img-fluid"
          />
        </div>
        <div class="card-body p-1">
          <h4 class="card-title font-oxygen text-center my-2 h4">
            {{ project.title }}
          </h4>
          <h6 class="font-oxygen text-center h6">
            {{ project.info }}
          </h6>
        </div>
        <div class="options justify-content-center p-2">
          <div
            class="dropdown-divider my-1"
            [ngClass]="{ 'border-light': themeService.flag }"
          ></div>
          <div
            class="text-center d-inline-block p-0 py-2 font-raleway text-danger"
            [ngClass]="{
              'col-6': project.link_available,
              'col-12': !project.link_available
            }"
          >
            <a (click)="navigate('projects/project/' + project.id)" class="red"
              >VIEW DETAILS</a
            >
          </div>
          <div
            *ngIf="project.git && project.link_available"
            class="
              text-center
              col-6
              d-inline-block
              p-0
              py-2
              font-raleway
              text-secondary
            "
          >
            <a [href]="project.link" target="_blank">GITHUB</a>
          </div>
          <div
            *ngIf="!project.git && project.link_available"
            class="
              text-center
              col-6
              d-inline-block
              p-0
              py-2
              font-raleway
              text-secondary
            "
          >
            <a [href]="project.link" target="_blank">LINK</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="btn mybtn depth m-3 mt-4"
      [ngClass]="{ 'mybtn-dark': themeService.flag }"
      (click)="navigate('\projects')"
    >
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      <span class="h5 ml-2">Know More...</span>
    </button>
  </div>
</div>
